import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";
import {TextInput} from "@FRAMEWORK/ui/mobile/input";
import {format} from "@yb/utils";
import {useState} from "react";

interface Props {
	initialPrice: {minPrice: string; maxPrice: string};
	minPricePlaceholder: string;
	maxPricePlaceholder: string;
	handlePriceText: (min: string, max: string) => void;
}

const TravelBudgetComponent = ({initialPrice, minPricePlaceholder, maxPricePlaceholder, handlePriceText}: Props) => {
	const [price, setPrice] = useState(initialPrice);

	return (
		<style.InputWrap>
			<TextInput
				type="number"
				placeholder={`₩${format.koKRFormatNumber(minPricePlaceholder)}`}
				onChange={e => setPrice(prev => ({...prev, minPrice: e.target.value}))}
				value={price.minPrice}
				onBlur={() => {
					if (!price.minPrice) return;
					handlePriceText(price.minPrice, price.maxPrice ? price.maxPrice : maxPricePlaceholder);
				}}
			/>
			~
			<TextInput
				type="number"
				placeholder={`₩${format.koKRFormatNumber(maxPricePlaceholder)}`}
				onChange={e => setPrice(prev => ({...prev, maxPrice: e.target.value}))}
				value={price.maxPrice}
				onBlur={() => {
					if (!price.maxPrice) return;
					handlePriceText(price.minPrice ? price.minPrice : minPricePlaceholder, price.maxPrice);
				}}
			/>
		</style.InputWrap>
	);
};

const TravelBudget = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter TravelBudget Error">
		<TravelBudgetComponent {...props} />
	</ErrorBoundary>
);

export default TravelBudget;
